const WEBSITE_DOMAIN = process.env.REACT_APP_WEBSITE_DOMAIN;
const API_ROOT = process.env.REACT_APP_API_ROOT;
const API_ROOT_ADMIN = process.env.REACT_APP_API_ROOT_ADMIN;
const API_ROOT_USER = process.env.REACT_APP_API_ROOT_USER;
const DECRYPT_KEY = process.env.REACT_APP_DECRYPT_KEY;
const ENCRYPT_KEY = process.env.REACT_APP_ENCRYPT_KEY;

export { WEBSITE_DOMAIN, API_ROOT, API_ROOT_ADMIN, API_ROOT_USER, DECRYPT_KEY, ENCRYPT_KEY };
